import { createVNode as r, mergeProps as n } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PleaseWaitingTwotoneStandard.js";
import s from "../components/PfIcon.js";
const t = (e, a) => {
  const o = {
    ...e,
    ...a.attrs
  };
  return r(s, n(o, {
    icon: i
  }), null);
};
t.displayName = "PleaseWaitingTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
